import { Info } from "lucide-react";

import style from "./PCRSSchemeSkippedNotice.module.css";

export const PCRSSchemeSkippedNotice = () => {
  return (
    <div className={style.notice} role="status">
      <Info size={20} className={style.icon} />
      <p className={style.text}>
        PCRS scheme check skipped — this patient is private, so the GMS scheme
        check was not performed.
      </p>
    </div>
  );
};
